// @ts-check

import { useMutation, useQuery } from "@tanstack/react-query"
import { atom, useAtom } from "jotai"
import { useSelector } from "react-redux"
import { ChatProjectQueryOptions, ChatProjectMutationOptions } from "./query"

const activeProjectIdAtom = atom(/**@type{string | null}*/(null))

function useActiveProjectId() {
  return useAtom(activeProjectIdAtom)
}

function useChatProjects() {
  // @ts-ignore
  const { user } = useSelector((state) => state.app.datastate)

  return useQuery(
    ChatProjectQueryOptions.CHAT_PROJECTS(user?.userToken)
  )
}

function useCreateChatProject() {
  const [_, setActiveProjectId] = useActiveProjectId()
  const { user } = useSelector((state) => state.app.datastate)

  const mutationOptions = ChatProjectMutationOptions.CREATE_NEW_PROJECT({
    userToken: user?.userToken
  })

  return useMutation({
    ...mutationOptions,
    onSuccess: (data, variables, mutationResult, context) => {
      mutationOptions.onSuccess?.(data, variables, mutationResult, context)
      // @ts-ignore
      setActiveProjectId(data.project._id)
    }
  })
}

export * from "./query"
export {
  activeProjectIdAtom,
  useActiveProjectId,

  useChatProjects,

  useCreateChatProject,
}
